module.exports = __webpack_public_path__ + "images/柏纳s长图_08-2.jpg?v=3c543307";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_08-2.jpg
 ** module id = 168
 ** module chunks = 1 2
 **/